// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import GET_AUTO_MESSAGES_FOR_ORG_QUERY from './queries/GetAutoMessagesForOrg.gql';
import SAVE_AUTO_MESSAGE_MUTATION from 'admin/components/AdminNewAutoMessage/queries/SaveAutoMessageMutation.gql';

import {
  type AdminAutoMessages,
  type AdminAutoMessages_organizations,
  type SaveAutoMessageInput,
} from './queries/__generated__/AdminAutoMessages';

type Props = {
  children: (props: {
    loading: ?boolean,
    refetchAutoMessagesForOrg: ?() => void,
    organization: ?AdminAutoMessages_organizations,
    saveAutoMessage: (input: SaveAutoMessageInput) => Promise<*>,
  }) => React.Node,
  data: ReactApolloData<AdminAutoMessages>,
  viewingOrgUuid: string,
  save: (input: SaveAutoMessageInput, viewingOrgUuid: string) => Promise<*>,
};

class AdminAutoMessagesContainer extends React.Component<Props, void> {
  render() {
    const { children, save, data, viewingOrgUuid } = this.props;
    return children({
      loading: idx(data, _ => _.loading),
      refetchAutoMessagesForOrg: idx(data, _ => _.refetch),
      organization: idx(data, _ => _.organizations[0]),
      saveAutoMessage: input => save(input, viewingOrgUuid),
      viewingOrgUuid,
    });
  }
}

const withAutoMessages = graphql(GET_AUTO_MESSAGES_FOR_ORG_QUERY, {
  options: ({ viewingOrgUuid }) => ({
    variables: { organizationUUID: viewingOrgUuid },
    // TODO: remove polling in favor of subscription for updating the last send column
    pollInterval: 3 * 1000,
    errorPolicy: 'all',
  }),
});

const withSaveMutation = graphql(SAVE_AUTO_MESSAGE_MUTATION, {
  props: ({ mutate }) => ({
    save(input: SaveAutoMessageInput, viewingOrgUuid: string) {
      return mutate({
        variables: { input },
        refetchQueries: [
          {
            query: GET_AUTO_MESSAGES_FOR_ORG_QUERY,
            variables: { organizationUUID: viewingOrgUuid },
          },
        ],
      });
    },
  }),
});

export { AdminAutoMessagesContainer };

export default compose(
  withAutoMessages,
  withSaveMutation
)(AdminAutoMessagesContainer);
